import React, { useState } from 'react';
import { WhatsAppContext } from "./WhatsAppContext";
import parsePhoneNumber from 'libphonenumber-js';
import moment from 'moment-timezone';

const classes = {
    root: {
        display: 'flex',
        flexDirection: 'row',
        height: '92vh',
        margin: '60px auto',
        background: '#fff',
        padding: 0,
        borderRadius: '7px'
    },
    chatList: {
        width: '30%',
        borderRight: `1px solid grey`,
        minHeight:'100%',
        maxHeight:'100%',
        overflowX: 'hidden',
        overflowY: 'scroll',
        position: 'relative'
    },
    chatListSidebar: {
        paddingTop: "0rem"
    },
    chatWindow: {
        flex: 1,
        padding: '1em',
        maxWidth:"100%"
    },
    searchField: {
        width: "100%",
        marginBottom: '0em',
        position: 'sticky',
        background: 'white',
        color: 'black',
        zIndex: "9",
        top: "0"
    },
    avatar: {
        height: '22px',
        marginRight: '2em',
    },
    messageContainer: {
        marginTop: '2em',
        maxWidth: '100%',
        minHeight:'85%',
        maxHeight:'85%',
        overflowX: 'auto',
        overflowY: 'scroll'
    },
    myMessageContainer: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        paddingRight: '18px',
    },
    myMessage: {
      position: 'relative',
      width: 'fit-content',
      maxWidth: '50%',
      backgroundColor: '#DCF8C6',
      borderRadius: '10px',
      padding: '2em',
      marginBottom: '1em',
      textAlign: 'right',
      wordBreak: 'break-word',
      alignItems: 'flex-end',
      textAlign: 'left',
      paddingTop: '1em',
      paddingBottom: '1em',
    },
    otherMessageContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      paddingLeft: '18px',
    },
    otherMessage: {
      position: 'relative',
      width: 'fit-content',
      maxWidth: '50%',
      backgroundColor: '#E0E0E0',
      borderRadius: '10px',
      padding: '1em',
      marginBottom: '1em',
      wordBreak: 'break-word',
    },
    loadMoreButton: {
        display: 'block',
        margin: '0 auto',
        marginTop: '2em',
        marginBottom: '2em',
    },
    lastMessagePreview: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
};

export function WhatsAppChatScreen() {
  // - Context
  const {
    isLoading,
    operator,
    websocketInstance,
    waData,
    waChatList,
    waContactsList,
    setWaData
  } = React.useContext(WhatsAppContext);
  // - States
  const [chatListInfo, setChatListInfo] = React.useState(<></>);
  const [currentChatPage, setCurrentPage] = React.useState(1);
  // - Refs
  const chatWindowRef = React.useRef(null);
  const isAutoScrollEnabled = React.useRef(true);

  const updateChatList = () => {
    const storedChatList = localStorage.getItem('waChatList');
    if (storedChatList) {
      const localwaChatList = JSON.parse(storedChatList);
  
      if (localwaChatList.length > 0 && waContactsList.length > 0) {
        const chatList = localwaChatList
          .filter(chat => chat) // Filter out any potential null values
          .map(chat => {
            const hasContact = waContactsList.find(contact => contact?.id === chat?.id);
            const lastMessage = chat.lastMessage ? (Object.keys(chat.lastMessage).length > 0 ? chat.lastMessage : null) : null;

            var chatName = chat.id;
            if (!chatName.includes("@g")) {
              if (hasContact) {
                chatName = hasContact.pushName;
              } else {
                let split = chat.id.split("@");
                chatName = parsePhoneNumber(split[0], 'BR');
                if (!chatName) {
                  chatName = chat.id
                } else {
                  chatName = `+${chatName.countryCallingCode} ${chatName.nationalNumber}`;
                }
              }
            }

            let chatMessagePreview = null;
            let chatMessageDate = null;
            if (lastMessage) {
              chatMessagePreview = interpretMessage(true, lastMessage);
              if (chat.id.includes("@g")) {
                if (!lastMessage.key.fromMe) {
                  chatMessagePreview = `~${lastMessage.pushName}: ${chatMessagePreview}`;
                } else {
                  chatMessagePreview = `Você: ${chatMessagePreview}`;
                }
              } else {
                if (lastMessage.key.fromMe) {
                  chatMessagePreview = `Você: ${chatMessagePreview}`;
                }
              }
              if (chatMessagePreview) {
                if (chatMessagePreview.length > 30) {
                  chatMessagePreview = chatMessagePreview.substring(0, 30) + "...";
                }
              }

              const messageTs = parseInt(lastMessage.messageTimestamp)*1000;
              let daysDiff = moment().tz("America/Sao_Paulo").diff(messageTs, 'days');
              console.log('daysDiff', daysDiff);
              if (daysDiff < 7) {
                if (daysDiff == 0) {
                  chatMessageDate = moment(messageTs).tz("America/Sao_Paulo").format('HH:mm');
                } else if (daysDiff == 1) {
                  chatMessageDate = 'Ontem';
                } else {
                  chatMessageDate = moment(messageTs).tz("America/Sao_Paulo").format('dddd');
                }
              } else {
                chatMessageDate = moment(messageTs).tz("America/Sao_Paulo").format('DD/MM/YYYY');
              }
            }

            return (
              <div
                className="list-group-item chat-list-item active"
                key={chat.id} 
                onClick={() => handleChatClick(chat.id)}
              >
                <div>
                  <img
                    alt={chatName}
                    src={hasContact ? (!hasContact.profilePictureUrl ? 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/default-avatar.png' : hasContact.profilePictureUrl) : 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/default-avatar.png'}
                    style={classes.avatar}
                    className="rounded-circle me-2"
                  />
                </div>
                <div>
                <div className="fw-bold" variant="subtitle1">
                  {chatName}
                </div>
                {lastMessage && (
                  <small>
                    <span className="lastMessagePreview">{chatMessagePreview}</span>
                    <br />
                    <span className="lastMessagePreview">{chatMessageDate}</span>
                  </small>
                )}
                </div>
              </div>
            );
          });
        setChatListInfo(chatList);
      } else {
        setChatListInfo('');
      }
    }
  };

  const interpretMessage = (is_chat_list = true, message_data) => {
    //console.log('[interpretMessage] message', message_data);
    if (message_data?.message?.conversation) {
      //console.log('message.conversation', message_data.message.conversation);
      return message_data.message.conversation;
    }

    if (message_data?.message?.extendedTextMessage) {
      //console.log('message.extendedTextMessage', message_data.message.extendedTextMessage);
      return message_data.message.extendedTextMessage.text;
    }

    if (message_data?.message?.audioMessage) {
      //console.log('message.audioMessage', message_data.message.audioMessage);
      return `SISTEMA: Aúdio ${message_data?.key?.fromMe ? 'Enviado' : 'Recebido, veja pelo celular'}.` /*is_chat_list ? `Recebeu Aúdio` : (
        <>
          <audio controls>
              <source src={message_data.message.audioMessage.url} type="audio/ogg" />
              Your browser does not support the audio element.
          </audio>
        </>
      );*/
    }

    if (message_data?.message?.viewOnceMessageV2) {
      return `SISTEMA: Mensagem de visualização única, veja pelo celular.`
    }

    if (message_data?.message?.stickerMessage) {
      return `**Figurinha**`
    }

    if (message_data?.message?.imageMessage) {
      return `**Imagem**`
    }

    if (message_data?.message?.editedMessage?.message?.protocolMessage?.editedMessage) {
      /*var oldMessages = waData.currentChatMessages;
      for(let x = 0; x < oldMessages.length; x++) {
        if (oldMessages[x]?.key?.id === message_data?.message?.editedMessage?.message?.protocolMessage?.key?.id) {
          oldMessages[x].message.conversation = message_data?.message?.editedMessage?.message?.protocolMessage?.editedMessage?.conversation;
        }
      }
      console.log('oldMessages', oldMessages);
      const newData = {
        ...waData,
        currentChatMessages: oldMessages
      };
      setWaData(newData)
      localStorage.setItem('waData', JSON.stringify(newData));*/
      return `** Edição de mensagem **`;
    }

    console.log('non interpretedMessage', message_data);
  }
  
  React.useEffect(() => {
    // Watching changes in 'waChatList' or 'waContactsList'
    updateChatList();
  }, [waChatList, waContactsList]); // Assuming these are the relevant dependencies
  
  // The dependency `localStorage.getItem('waChatList')` might not work directly inside the useEffect dependency array.
  // So, as an alternative, you can set up a separate state to trigger an update when the localStorage changes.
  React.useEffect(() => {
    updateChatList();

    const handleStorageChange = () => {
      updateChatList();
    };
  
    // Listen to the storage event to detect changes in the 'waChatList'
    window.addEventListener('storage', handleStorageChange);
  
    return () => {
      // Clean up the event listener on component unmount
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []); // No dependencies, so it only runs once during the component's lifecycle
  

  /**
   * @name handleChatClick
   * @param {*} chat_id 
   * @description Detecta quando usuário clicar em uma conversa
   * para ler as mensgens
   */
  const handleChatClick = (chat_id) => {
    if (websocketInstance.current) {
      websocketInstance.current.emit('data', {
        cmd: 'fetchChatMessages',
        payload: {
          chat_id: chat_id,
          operator_id: operator.id,
          company_id: operator.company_id,
          branch_id: operator.branch_id,
        }
      })
      $('#react-container').block(window._loader.loading);
      setCurrentPage(1)
    }
  };

  /**
   * @name handleScroll
   * @description Callback para detectar posição do scroll
   */
  const handleScroll = () => {
    // Verifica se o usuário está na parte colado no final do scroll (inicio das mensagems)
    const { scrollTop, scrollHeight, clientHeight } = chatWindowRef.current;
    isAutoScrollEnabled.current = scrollHeight - scrollTop === clientHeight;
  };

  /**
   * @name scrollToBottom
   * @description Força scroll para o início das mensagens atuais (final do scroll)
   */
  const scrollToBottom = () => {
    if (chatWindowRef.current && isAutoScrollEnabled.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  };

  // Detecta quando houver mudanças nas mensagens para dar scroll para o início das conversas
  // caso não esteja visualizando mensagens antigas..
  React.useEffect(() => {
    if (waData.currentChatId !== false || waData.currentChatMessages.length > 0) {
        scrollToBottom();
    }
  }, [waData]);

  const [message, setMessage] = useState('');

  const handleInputChange = (event) => {
    setMessage(event.target.value);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    //onSendMessage(message);
    if (websocketInstance.current) {
      websocketInstance.current.emit('data', {
        cmd: 'sendTextMessage',
        payload: {
          chat_id: waData.currentChatId,
          operator_id: operator.id,
          company_id: operator.company_id,
          branch_id: operator.branch_id,
          value: message
        }
      })
    }
    setMessage('');
  };

  const [chatName, setChatName] = useState('');
  React.useEffect(() => {
    if (waData.currentChatId) {
      let split = waData.currentChatId.split("@");
      let chatName = parsePhoneNumber(split[0], 'BR');
      const hasContact = waContactsList.find(contact => contact?.id === waData.currentChatId);
      if (hasContact) {
        chatName = hasContact.pushName;
      } else {
        if (chatName) {
          chatName = `+${chatName.countryCallingCode} ${chatName.nationalNumber}`;
        } else {
          chatName = waData.currentChatId;
        }
      }
      setChatName(chatName);
    }
  }, [waData.currentChatId]);

  return (
    <div style={classes.root}>
      <div style={classes.chatList}>
        <input 
          type="text"
          className="form-control"
          style={classes.searchField}
          variant="outlined"
          placeholder="Buscar conversa..."
        />
        <div className="list-group" style={classes.chatListSidebar}>
          {chatListInfo}
        </div>
      </div>
      <div style={classes.chatWindow}>
        {waData.currentChatId ? (
          <>
            <h6>Conversa com {chatName}</h6>
            <hr className="divider" />
            <div style={classes.messageContainer} ref={chatWindowRef} onScroll={handleScroll}>
              <button
                className="btn btn-primary"
                variant="outlined"
                color="primary"
                style={classes.loadMoreButton}
                onClick={() => {
                  if (websocketInstance.current) {
                      setCurrentPage(parseInt(currentChatPage) + 1);
                      websocketInstance.current.emit('data', {
                          cmd: 'fetchChatMessages',
                          payload: {
                              chat_id: waData.currentChatId,
                              operator_id: operator.id,
                              company_id: operator.company_id,
                              branch_id: operator.branch_id,
                              page: parseInt(currentChatPage) + 1
                          }
                      })
                  }
                }}
              >
                Carregar mais
              </button>
              {waData.currentChatMessages.map((message, index) => { 
                const isEditedMessage = waData.currentChatMessages.find((message2) =>  {
                  return message?.key?.id === message2?.message?.editedMessage?.message?.protocolMessage?.key?.id
                });

                if (isEditedMessage) {
                  message.message = isEditedMessage?.message.editedMessage?.message?.protocolMessage?.editedMessage;
                }

                if (!message?.message?.editedMessage) {
                  let sentTime = moment(parseInt(message.messageTimestamp)*1000).tz("America/Sao_Paulo").format('HH:mm')
                  let sentDate = moment(parseInt(message.messageTimestamp)*1000).tz("America/Sao_Paulo").format('DD/MM/YYYY')
                  return (
                    <div
                      key={index}
                      style={message.key.fromMe ? classes.myMessageContainer : classes.otherMessageContainer}
                    >
                      <div style={message.key.fromMe ? classes.myMessage : classes.otherMessage}>
                        {message.key.remoteJid.includes("@g.us") && !message.key.fromMe ? (<>~{message.pushName}:<br /></>) : ""}
                        {interpretMessage(false, message)}
                        <div style={{
                          float: 'right',
                          fontSize: '10px',
                          marginBottom: '-5px',
                          marginTop: '18px'
                        }}>
                          {sentDate} {sentTime}
                        </div>
                      </div>
                    </div>
                  )
                }
              })}
            </div>
            <form onSubmit={handleFormSubmit}>
              <div className="row p-1">
                <div className="col-10">
                  <input 
                    className="form-control"
                    type="text"
                    fullWidth
                    label="Digite uma mensagem"
                    value={message}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-2">
                  <button className="btn btn-primary" variant="contained" color="primary" type="submit">
                    Enviar
                  </button>
                </div>
              </div>
            </form>
          </>
        ) : (
          <h6 variant="h6">Selecione uma conversa</h6>
        )}
        <hr className="divider" />
      </div>
    </div>
  );
}